import { render, staticRenderFns } from "./SchemeList.vue?vue&type=template&id=2e8e6755&scoped=true&"
import script from "./SchemeList.vue?vue&type=script&lang=js&"
export * from "./SchemeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8e6755",
  null
  
)

export default component.exports